<form class="lv-artefact-container lv-component"
      [ngClass]="!!uiArtefakt?.Ausrichtung ? uiArtefakt?.Ausrichtung : uiAusrichtung">
  <div class="lv-artefact"
       [ngClass]="{'lv-error-state': !!isInvalid()}">
    <ng-container *ngIf="!uiArtefakt.ListeErweiterbarJN">
      <div [ngClass]="uiArtefakt.BreiteInPixel"
           *ngFor="let item of uiArtefakt.UIArtefakt,trackBy: trackByFn">
        <lv-uiartefakt-renderer [uiArtefakt]="item"></lv-uiartefakt-renderer>
      </div>
    </ng-container>
    <ng-container *ngIf="uiArtefakt.ListeErweiterbarJN">
      <input #lvHiddenInput="ngModel" [name]="'lvHidden'" [(ngModel)]="hiddenInputmodel"
             class="lv-hidden-form" lvMinMaxValidator [minValue]="uiArtefakt.ListenelementeMin"
             [maxValue]="uiArtefakt.ListenelementeMax">
      <lv-label-tooltip [label]="uiArtefakt.Text" [labelSymbol]="nestedSymbol"
                        [tooltip]="uiArtefakt.InfoTextTooltipCollapsable"
                        [isPflichtfeld]="uiArtefakt.PflichtfeldJN"
                        [isCollapsable]="uiArtefakt.InfoTextTooltipCollapsableTyp === 'Collapsable'"
                        (infotextCollapsableChange)="infotextCollapsableChange($event)"></lv-label-tooltip>
      <lv-info-text-tooltip-collapsable [showInfotext]="showInfotextCollapsable"
                                        [tooltip]="uiArtefakt.InfoTextTooltipCollapsable"></lv-info-text-tooltip-collapsable>

      <div class="lv-flex" *ngFor="let item of uiArtefakt.UIArtefakt,trackBy: trackByFn; let i=index" [@inOut]>
        <ng-container *ngIf="item.Identifikator.indexOf('@') > 0 || !!uiArtefakt.ListenelementeMin || initalTemplateUsed">
          <div [ngClass]="uiArtefakt.BreiteInPixel">
            <div [ngClass]="{'lv-listitem': !minEqualsMax(), 'lv-listitem-no-border': minEqualsMax()}">
            <lv-uiartefakt-renderer [uiArtefakt]="item"></lv-uiartefakt-renderer>
          </div>
          </div>
          <div *ngIf="!minEqualsMax()" class="lv-trash-box">
            <mat-icon [ngClass]="{'lv-trash-icon-disabled': hasReachedMin()}" svgIcon="Trash" (click)="removeEntry(i)"></mat-icon>
          </div>
        </ng-container>
      </div>

      <div class="lv-flex">
        <button *ngIf="!minEqualsMax()" mat-raised-button color="accent" class="lv-plus-button" (click)="addEntryFromTemplate()" [disabled]="hasReachedMax()">
          <div *ngIf="showSpinner">
            <mat-progress-spinner class="lv-progress-spinner-white" mode="indeterminate" [diameter]="20"></mat-progress-spinner>
          </div>
          <div *ngIf="!showSpinner">
            Hinzufügen
          </div>
        </button>
        <lv-infotext-permanent *ngIf="!minEqualsMax()" [InfoTextPermanent]="hasReachedMax() ? 'maximale Anzahl erreicht' : null" class="lv-has-reached-max-info">
        </lv-infotext-permanent>
      </div>
      <div>
        <mat-error class="lv-error-meldung-liste" [ngClass]="uiArtefakt.BreiteInPixel"
                   *ngIf="getError() as error" (click)="onErrorClick()">
          <div class="lv-control-error"
               [ngClass]="{'lv-show-untruncated-error': showUntruncatedError}">{{error}}</div>
        </mat-error>
      </div>
    </ng-container>
  </div>
</form>
